import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Servicenowadmintemplate from "../../component/course/servicenow-admin";


export default class servicenowadminindelhi extends Component {
  render() {

    const title = "ServiceNow Admin"
    const url= "servicenow-admin"
    const url1 ="-training-in-delhi"
    const location = "delhi" 
    const location1="Training in Delhi"
    return (
      <>
        <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
          description={`Do you want to accelerate your career growth and unlock endless possibilities in your field? If yes, then Learnsoft ${location} is the perfect place for you! Our comprehensive ServiceNow Admin training program is designed to help you become a proficient ServiceNow Admin with hands-on experience and expert guidance from our experienced trainers`}
          url={`${location}/${url}${url1}`}
          img={`course/${url}.webp`}
          keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}        />
        <Layout navbarBackgroundColor="#281E1E">
          <Servicenowadmintemplate url1={url1}  title={title} url={url} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
